/*
The mobile/Drawer component is a vertically scrollable
drawer containing lists of links nested up to 3 levels deep.

Some nested mobile menu components are mobile/Category and
mobile/Subcategory components with lists that expand vertically
by CSS transitioning height when an .isOpen class is applied:

<div class='Category'>
  <button class='toggle' />
  <ul class='CategoryList isOpen'>...</ul>
</div>

<div class='Subcategory'>
  <button class='toggle' />
  <ul class='SubcategoryList isOpen'>...</ul>
</div>

When a Category/Subcategory opens, its sibling menus close,
so it's possible that the top of the opening menu may scroll
out of view, i.e. past the top of the drawer viewport.

This code listens for height transitions when .isOpen is
applied to a menu list, finds the parent menu, and ensures
the top of the opening menu does not scroll past the top
of the drawer viewport.
*/
export function drawerScrollClamp(drawer) {
    let list, menu;
    let isTransitioning = false;
    function isMenuOpening(e) {
        return (e.propertyName === 'height' &&
            e.target.classList.contains('isOpen') &&
            (e.target.classList.contains('CategoryList') || e.target.classList.contains('SubcategoryList')));
    }
    function onTransitionStart(e) {
        // if this is the start of a menu opening, start the animation loop
        if (isMenuOpening(e)) {
            isTransitioning = true;
            list = e.target;
            menu = list.closest('.Subcategory, .Category');
            requestAnimationFrame(onTransitionTick);
        }
    }
    function onTransitionTick() {
        if (isTransitioning) {
            clampScroll();
            requestAnimationFrame(onTransitionTick);
        }
    }
    function clampScroll() {
        const menuTop = menu.getBoundingClientRect().top;
        const drawerTop = drawer.getBoundingClientRect().top;
        // ensure that the top of the open menu
        // does not go above the top of the drawer
        if (menuTop < drawerTop) {
            const delta = drawerTop - menuTop;
            const destination = Math.round(drawer.scrollTop - delta);
            drawer.scrollTo({ top: destination, left: 0 });
        }
    }
    function onTransitionEnd(e) {
        // if this is the end of the menu opening, end the animation loop
        if (e.target === list && e.propertyName === 'height') {
            isTransitioning = false;
            clampScroll();
            list = menu = null;
        }
    }
    drawer.addEventListener('transitionstart', onTransitionStart);
    drawer.addEventListener('transitionend', onTransitionEnd);
    return {
        destroy() {
            drawer.removeEventListener('transitionstart', onTransitionStart);
            drawer.removeEventListener('transitionend', onTransitionEnd);
        },
    };
}
